import moment from "moment-timezone";
import { daysBetween } from "./Times";
import { enqueueSnackbar } from "notistack";
import { ScheduleService } from "services/ScheduleService";

const scheduleService = new ScheduleService()

// ----------------- Schedule -----------------
const gettingSchedule = async (setLoading, setRows, employees, range) => {
	if (
		!Array.isArray(employees) ||
		employees.length === 0 ||
		!range?.[0] ||
		!range?.[1] ||
		!range[0].isValid() ||
		!range[1].isValid()
	) {
		setRows([]);
		setLoading(false);
		return;
	}

	setLoading(true);

	let employeesFiltered = [...new Set(employees.map((e) => e.id))].join(",");

	let employeeForRows = [];

	for (let emp of employees) {
		let element = employeeForRows.find((e) => e?.id === emp?.id);

		if (!element) {
			employeeForRows.push(emp);
		}
	}

	await scheduleService.schedule.getSchedules(
		employeesFiltered,
		range[0].format("YYYY-MM-DD"),
		range[1].format("YYYY-MM-DD")
	)
		.then((response) => {
			let rows = employeeForRows.map((employee) => {
				let row = {
					id: employee?.id,
					document_employee: employee?.document_employee,
					full_name: employee?.full_name,
					planned_hours: [],
					pay_period_end: employee?.pay_period_end,
					contract_end_date: employee?.contract_end_date,
				};

				for (let day of daysBetween(range[0], range[1])) {
					row[day] = {
						shifts: response?.filter(
							(shift) =>
								shift.employee_id === employee.id &&
								shift.date === day
						),
						hours: [],
						days: [],
					};
				}

				return row;
			});

			for (let row of rows) {
				for (let day of daysBetween(range[0], range[1])) {
					row[day].paycodeAssign = [];
				}
			}

			console.log("rows", rows);
			setRows(rows);
		})
		.catch((error) => {
			console.error(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const gettingShiftById = async (
	setLoading,
	shift_id,
	employees,
	setSelectedEmployees,
	setSelectedDay,
	setRows
) => {
	setLoading(true);
	console.log("employees", employees);

	scheduleService.schedule.getScheduleById(shift_id)
		.then((response) => {
			setSelectedEmployees(
				employees
					.filter(
						(employee) =>
							employee.id === response.employee_id
					)
					.map((employee) => employee.full_name)
			);
			setSelectedDay(
				moment(
					`${response.date} ${response.start_ts}`,
					"YYYY-MM-DD HH:mm:ss"
				)
			);
			setRows(
				response.segments.map((segment) => ({
					id: segment.segment_id,
					start_ts: moment(
						segment.start_ts,
						"YYYY-MM-DDTHH:mm:ssZ"
					).local(),
					end_ts: moment(
						segment.end_ts,
						"YYYY-MM-DDTHH:mm:ssZ"
					).local(),
					type: segment.type,
				}))
			);
		})
		.catch((error) => {
			console.error(error.message);
		})
		.finally(() => {
			setLoading(false);
		});
};

const addingShift = async (
	setLoading,
	employees,
	date,
	counter,
	start_ts,
	end_ts,
	duration,
	timezone,
	segments,
	closing,
	reloading,
	handlerAlertLocal
) => {
	setLoading(true);

	const body = {
		date,
		start_ts,
		end_ts,
		duration,
		timezone,
		override: false,
		scheduler_create: false,
		enable: true,
		segments: segments.map((segment) => {
			// const [year, month, day] = date.split("-");

			const start_ts = segment.start_ts
				.clone()
				.add(counter, "days")
				.toISOString();

			const end_ts = segment.end_ts
				.clone()
				.add(counter, "days")
				.toISOString();

			return {
				type: segment.type,
				start_ts,
				end_ts,
			};
		}),
	};

	let promises = employees.map((id) =>
		scheduleService.schedule.createSchedule(
			{ ...body, employee_id: id }
		)
	);

	Promise.allSettled(promises)
		.then((results) => {
			console.error("results", results);

			results.forEach((result) => {
				if (result.status === "rejected") {
					enqueueSnackbar(result?.reason?.response?.data?.detail, {
						variant: "error",
					});
				} else {
					enqueueSnackbar("200: Horario creado con exito", {
						variant: "success",
					});
				}
			});

			closing();
			reloading();
		})

		.finally(() => {
			setLoading(false);
		});
};

const editingShift = async (
	setLoading,
	shift_id,
	employee_id,
	date,
	start_ts,
	end_ts,
	duration,
	timezone,
	segments,
	closing,
	reloading,
	handlerAlertLocal
) => {
	setLoading(true);

	const body = {
		employee_id,
		date,
		start_ts,
		end_ts,
		duration,
		timezone,
		override: false,
		scheduler_create: false,
		enable: true,
		segments: segments.map((segment) => ({
			type: segment.type,
			start_ts: segment.start_ts.toISOString(),
			end_ts: segment.end_ts.toISOString(),
		})),
	};
	scheduleService.schedule.updateSchedule(shift_id, body)
		.then(() => {
			closing();
			reloading();
		})
		.catch((error) => {
			console.error(error.message);

			enqueueSnackbar(error?.response?.data?.detail, {
				variant: "error",
			});
		})
		.finally(() => {
			setLoading(false);
		});
};

const deletingShift = async (setLoading, shift_id, closing, reloading) => {
	setLoading(true);

	scheduleService.schedule.deleteSchedule(shift_id)
		.then(() => {
			reloading(true);
			closing();
		})
		.catch((error) => {
			console.error(error.message);

			enqueueSnackbar(error?.response?.data?.detail, {
				variant: "error",
			});
		})
		.finally(() => {
			setLoading(false);
		});
};

export {
	gettingShiftById,
	gettingSchedule,
	addingShift,
	editingShift,
	deletingShift,
};
